<h2 mat-dialog-title>{{ 'ADD_DOCUMENT' | translate }}</h2>

<mat-dialog-content [formGroup]="docForm">
    <div class="col-span-12">
     <mat-label>{{ 'DOCUMENT_NAME' | translate }}</mat-label>

    <mat-form-field appearance="outline" class="w-full">
      <mat-select formControlName="doc_name" [placeholder]="'SELECT_NAME' | translate">
        <mat-option value="">{{ 'SELECT_DOCUMENT' | translate }}</mat-option>
        <mat-option value="Feasibility Stage">{{ 'FEASIBILITY_STAGE' | translate }}</mat-option>
        <mat-option value="Sanction Stage">{{ 'SANCTION_STAGE' | translate }}</mat-option>
        <mat-option value="After Completion">{{ 'AFTER_COMPLETION' | translate }}</mat-option>
      </mat-select>
      <mat-error *ngIf="docForm.get('doc_name')?.invalid">{{ 'REQUIRED' | translate }}</mat-error>
    </mat-form-field>
    </div>
  
    <div class="col-span-12">
    <mat-label>{{ 'SELECTED_FILE' | translate }}</mat-label>

         <mat-form-field appearance="outline" class="w-full">
    <input matInput [value]="docForm.get('file_name')?.value" readonly placeholder="Choose file" />
    <button mat-icon-button matSuffix (click)="fileInput.click()" type="button">
      <mat-icon>upload</mat-icon>
    </button>
  </mat-form-field>
    </div>

 

  <input type="file" hidden (change)="onFileSelected($event)" #fileInput accept=".pdf,.doc,.docx,.png,.jpg" />
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">{{ 'CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="save()" [disabled]="docForm.invalid">  {{ 'SAVE' | translate }}</button>
</mat-dialog-actions>

